var exports = {
  "button": "MediaPlayButton.module__button___MWkyWl",
  "small": "MediaPlayButton.module__small___MWkyWl",
  "medium": "MediaPlayButton.module__medium___MWkyWl",
  "large": "MediaPlayButton.module__large___MWkyWl",
  "xlarge": "MediaPlayButton.module__xlarge___MWkyWl",
  "overlay": "MediaPlayButton.module__overlay___MWkyWl",
};

__webpack_require__.r(module.exports = exports);
